import { BrowserModule } from "@angular/platform-browser";
import { APP_INITIALIZER, NgModule } from "@angular/core";

import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { ComponentsModule } from "./components/components.module";
import { PagesModule } from "./pages/pages.module";

import { AngularFireModule } from "@angular/fire";
import { AngularFirestoreModule } from "@angular/fire/firestore";
import { environment } from "src/environments/environment";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { NgxMaskModule } from "ngx-mask";
import { HttpClientModule } from "@angular/common/http";
import { FontAwesomeModule } from "@fortawesome/angular-fontawesome";
import { RouterModule, Routes } from "@angular/router";
import { MailService } from "./services/mail.service";
import { TippyDirective } from './directives/tippy.directive';
import { AuthService } from "./services/auth.service";
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';


// function initializeApp(auth:AuthService) {
//   return ()=> auth.loadUser()
// }



const routes: Routes = [];
@NgModule({
  declarations: [AppComponent, TippyDirective],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FontAwesomeModule,
    ComponentsModule,
    PagesModule,
    AngularFireModule.initializeApp(environment.firebaseConfig),
    AngularFirestoreModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    NgxMaskModule.forRoot(),
    // BrowserAnimationsModule
  ],
  // providers: [MailService,{
  //   provide: APP_INITIALIZER,
  //   useFactory: initializeApp,
  //   multi: true,
  //   deps:[AuthService]
  //  }]
  //  ,
  bootstrap: [AppComponent],
})
export class AppModule {}
